import { environmentConfig } from '../config/environment';

export const buttonColors = {
  client: {
    primary: {
      background: '#006FEE',
      text: '#FFFFFF',
      disabled: {
        background: '#888C8E',
        text: '#FFFFFF',
        opacity: '0.5'
      }
    },
    secondary: {
      background: '#E6F1FE',
      text: '#006FEE',
      disabled: {
        background: '#888C8E',
        text: '#FFFFFF',
        opacity: '0.5'
      }
    }
  },
  partner: {
    primary: {
      background: '#006FEE', 
      text: '#FFFFFF',
      disabled: {
        background: '#888C8E',
        text: '#FFFFFF',
        opacity: '0.5'
      }
    },
    secondary: {
      background: '#E6F1FE',
      text: '#006FEE',
      disabled: {
        background: '#888C8E',
        text: '#FFFFFF',
        opacity: '0.5'
      }
    },
    tertiary:{
      background: '#F4F4F5',
      text: '#11181C',
      disabled: {
        background: '#888C8E',
        text: '#FFFFFF',
        opacity: '0.5'
      }
    }
  }
};

export const getCurrentButtonColors = () => {
  return window.location.pathname.startsWith('/partner') ? buttonColors.partner : buttonColors.client;
};

export const getButtonColorsByUserRole = (userRole?: string) => {
  if (window.location.pathname.startsWith('/partner')) {
    return buttonColors.partner;
  }
  return buttonColors.client;
};

export const getButtonVariantColorsByUserRole = (variant: 'primary' | 'secondary', userRole?: string) => {
  const colors = getButtonColorsByUserRole(userRole);
  return colors[variant];
};

export const getButtonVariantColors = (variant: 'primary' | 'secondary' | 'tertiary') => {
  const isPartner = window.location.pathname.startsWith('/partner');
  const colors:any = isPartner ? buttonColors.partner : buttonColors.client;
  return colors[variant];
};
